<div *ngIf="parent != undefined && parent.id == parent.selection">
    <aes-map [device]="device"></aes-map>
</div>